import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import { FeedbackService } from '../../lib/services/feedback/feedback.service';
import { StorageKeysEnum } from '../../lib/storage/storage-keys.enum';

@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
export class FeedbackComponent implements OnInit {
  urlBancaDigital: String = "";
  constructor(private router: Router,
              private feedbackService : FeedbackService) { }

  ngOnInit(): void {
    this.feedbackService.getURL().subscribe({
      next : value =>{
          if(value.code == 1){
            this.urlBancaDigital = value.message;
          }
      }
    })
  }

  showBancaDigital(){
    sessionStorage.removeItem(StorageKeysEnum.WELCOME);
    sessionStorage.removeItem(StorageKeysEnum.TOKEN_FEEDBACK);
    window.location.assign(this.urlBancaDigital+"");
  }
  showFormFeedback(){
    this.router.navigate(['/feedback-form']);
  }
  

}
